module.exports = __webpack_public_path__ + "static/img/project_banner1.6528c38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_banner1.png
// module id = Anhs
// module chunks = 1